import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, PageHeader, Spinner, Badge, Input, Select } from "@/components/ui";
import { Search, Stethoscope, Star } from "lucide-react";

export default function Providers() {
  const [items, setItems] = useState(null);
  const [search, setSearch] = useState("");
  const [specialty, setSpecialty] = useState("");

  useEffect(() => {
    const t = setTimeout(() => api.get("/providers", { params: { search, specialty } }).then((r) => setItems(r.data)), 250);
    return () => clearTimeout(t);
  }, [search, specialty]);

  const specialties = ["Psychiatry", "Behavioral Health Therapy", "Primary Care", "Neurology", "IDD Services", "Substance Use Treatment", "Case Management", "Peer Support", "Physical Therapy", "Pharmacy"];

  return (
    <div className="vc-fade-up">
      <PageHeader title="Provider Network" subtitle="Trillium builds and manages a network of qualified providers. Search, filter, and monitor network adequacy." />
      <Card className="p-4 mb-4 flex flex-col md:flex-row gap-3">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input className="pl-9" placeholder="Search providers, organizations, NPI…" value={search} onChange={(e) => setSearch(e.target.value)} data-testid="provider-search" />
        </div>
        <Select value={specialty} onChange={(e) => setSpecialty(e.target.value)} data-testid="provider-specialty">
          <option value="">All Specialties</option>{specialties.map((s) => <option key={s}>{s}</option>)}
        </Select>
      </Card>

      {items === null ? <Spinner /> : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((p) => (
            <Card key={p.id} className="p-5" hover data-testid="provider-card">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-md bg-brand-50 flex items-center justify-center"><Stethoscope className="h-5 w-5 text-brand-700" /></div>
                  <div><h3 className="font-semibold">{p.name}</h3><p className="text-xs text-muted-foreground">{p.specialty}</p></div>
                </div>
                <Badge tone={p.network_status}>{p.network_status}</Badge>
              </div>
              <div className="mt-4 space-y-1.5 text-sm text-muted-foreground">
                <p>{p.organization}</p>
                <p className="text-xs">{p.county} County · NPI <span className="font-mono">{p.npi}</span></p>
                <p className="text-xs">{p.phone}</p>
              </div>
              <div className="mt-4 flex items-center justify-between pt-3 border-t border-border">
                <span className="flex items-center gap-1 text-sm"><Star className="h-4 w-4 fill-amber-400 text-amber-400" /> {p.rating}</span>
                <span className={`text-xs font-semibold ${p.accepting_new ? "text-indigo-700" : "text-muted-foreground"}`}>{p.accepting_new ? "Accepting new" : "Not accepting"}</span>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
